import React from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

const RemarkModal = ({open, setOpen, setRemark, actionHandler}) => {
    return (
        <Modal
            isOpen={open}
            toggle={() => {
                setOpen(false);
            }}
            centered={true}
        >
            <ModalHeader>Remarks</ModalHeader>
            <ModalBody>
                <div>
                    <textarea
                        className="form-control"
                        id="exampleFormControlTextarea5"
                        rows="3"
                        onChange={(e) => setRemark(e.target.value)}
                    ></textarea>
                </div>
            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => actionHandler()}
                >
                    Submit
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default React.memo(RemarkModal);